export const categoriesFieldsName = ['id', 'title', 'cards'];
export const categoriesFieldsTypes = ['number', 'string', 'array'];
export const cardsFieldsName = ['id', 'content'];
export const cardsFieldsTypes = ['number', 'string'];